import { useEffect, useState } from "react";
import { navItems, siteName, ticker } from "@/mocks/gossip";

export default function TopNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* 顶部速递跑马灯 */}
      <div className="bg-foreground-950 text-background-100">
        <div className="mx-auto flex max-w-6xl items-center gap-3 px-4 py-2 text-xs md:px-6">
          <span className="flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-2.5 py-0.5 text-background-50 font-medium">
            <i className="ri-flashlight-fill text-[10px]"></i>
            今日瓜速递
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="animate-ticker flex flex-col text-foreground-200">
              {ticker.map((t) => (
                <span key={t} className="h-5 truncate leading-5">
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* 导航 */}
      <header
        className={`sticky top-0 z-40 w-full transition-all duration-300 ${
          scrolled
            ? "bg-background-50/95 shadow-soft backdrop-blur"
            : "bg-background-50"
        }`}
      >
        <nav
          className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 md:px-6"
          aria-label="主导航"
        >
          <a href="#top" className="flex items-center gap-2.5">
            <span className="relative flex h-10 w-10 items-center justify-center rounded-2xl bg-primary-500 text-background-50 shadow-soft">
              <i className="ri-community-line text-xl"></i>
              <span className="absolute -right-1 -top-1 h-3 w-3 rounded-full bg-accent-500 ring-2 ring-background-50"></span>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
                {siteName}
              </span>
              <span className="mt-1 text-[10px] text-foreground-500">
                校园八卦 · 热点追踪
              </span>
            </span>
          </a>

          <div className="hidden items-center gap-1 lg:flex">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="whitespace-nowrap rounded-full px-3.5 py-2 text-sm text-foreground-700 transition hover:bg-background-200 hover:text-foreground-950"
              >
                {item.label}
              </a>
            ))}
          </div>

          <div className="flex items-center gap-2">
            <a
              href="#plaza"
              className="hidden whitespace-nowrap items-center gap-1.5 rounded-full bg-foreground-950 px-4 py-2 text-sm text-background-50 transition hover:bg-primary-600 sm:inline-flex"
            >
              <i className="ri-chat-3-line"></i>
              围观唠嗑
            </a>
            <button
              type="button"
              aria-label="展开菜单"
              onClick={() => setOpen((v) => !v)}
              className="inline-flex h-10 w-10 items-center justify-center rounded-full text-foreground-900 transition hover:bg-background-200 lg:hidden"
            >
              <i className={`ri-${open ? "close-line" : "menu-line"} text-xl`}></i>
            </button>
          </div>
        </nav>

        {/* 移动端菜单 */}
        {open && (
          <div className="border-t border-background-200 bg-background-50 px-4 pb-4 lg:hidden">
            <div className="flex flex-col gap-1 pt-2">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="rounded-xl px-3 py-2.5 text-sm text-foreground-800 transition hover:bg-background-100"
                >
                  {item.label}
                </a>
              ))}
              <a
                href="#plaza"
                onClick={() => setOpen(false)}
                className="mt-1 inline-flex items-center justify-center gap-1.5 rounded-full bg-primary-500 px-4 py-2.5 text-sm text-background-50"
              >
                <i className="ri-chat-3-line"></i>
                围观唠嗑
              </a>
            </div>
          </div>
        )}
      </header>
    </>
  );
}